import React from 'react';

import propTypes from 'prop-types';
import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';

export default class QuickShopButton extends React.Component {
  static propTypes = {
    variants: propTypes.array.isRequired,
    openQuickShopModal: propTypes.func.isRequired,
    showExciseTaxDisclaimer: propTypes.bool.isRequired,
  };

  render() {
    const {
      variants,
      openQuickShopModal,
      showExciseTaxDisclaimer,
      taxonName,
    } = this.props;
    return (
      <Button
        className={
          'quickShopModal__Buton button--outline-soft button--full-width'
        }
        onClick={() =>
          openQuickShopModal(variants, showExciseTaxDisclaimer, taxonName)
        }
      >
        <TranslatedMessage id={'cart.quick_shop.quick_shop'} />
      </Button>
    );
  }
}
